import http from '../axios'

// 登录
export function login(params) {
  return http.post('/sign-up/login', params)
}

// 退出登录
export function logout(params) {
  return http.post('/user/logout', params)
}

// 判断是否登录
export function isLogin(params) {
  return http.post('/sign-up/is-login', params, {
    direct: true
  })
}

// 会员填写邮箱发送手机验证码登录
export function loginSendSms(params) {
  return http.post('/sign-up/login-send-sms', params)
}

// 会员手机验证码进行登录
export function loginBySms(params) {
  return http.post('/sign-up/login-by-sms', params)
}

// 找回密码之填写邮箱账号发送找回密码邮件接口
export function requestPasswordReset(params) {
  return http.post('/forget-pw/request-password-reset', params)
}

//找回密码之填写2次密码修改密码接口
export function resetPassword(params) {
  return http.post('/forget-pw/reset-password', params)
}
